import React, { useState, useRef, useEffect } from 'react'
import styles from "./Environmentpanel.module.css"
import CustomModal from './Modal';
import { useNavigate } from 'react-router-dom';
import { logout_Api, create_environment_Api, create_environment_file_Api, get_all_environment_Api, current_user_Api } from '../../dashboardapi';
import Environmentfiles from './Environmentfiles';
import data from "../../json/Config.json";
import { useToast } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const Environmentpanel = () => {

    const [showmodal, setShowModal] = useState(false);
    const [environmentTitle, setEnvironmentTitle] = useState("")
    const fileInputRef = useRef(null);
    const [dragging, setDragging] = useState(false);
    const [show, setShow] = useState(false);
    const [inputFiles, setInputFiles] = useState([]);
    const [environments, setEnvironments] = useState();
    const [showDetails, setShowDetails] = useState({ show: false, env: "", id: "" })
    const [userdetail, setUserDetail] = useState("")
    const ref = useRef();



    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target) && !event.target.closest(".togglebtn")) {
            setShow(false)
        }
    };

    const handledropdown = () => {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    useEffect(() => {
        let details = async () => {
            try {
                let result = await current_user_Api();
                if (result.data) {
                    setUserDetail(result.data.message)
                }
            } catch (error) {
                console.log(error);
            }
        }

        details();

        document.addEventListener('mousedown', handleClickOutside);
        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [])

    const navigate = useNavigate();

    const toast = useToast();

    useEffect(() => {
        fetchEnvironemnt()
    }, [])

    const fetchEnvironemnt = async () => {
        let result = await get_all_environment_Api();
        if (result.data) {
            setEnvironments(result.data)
        } else {
            const error = result.error.Message || "An error Occured";
            toast({
                title: "Problem getting Templates",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }


    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true); // Highlight the area when dragging files
    };

    const handleDragLeave = () => {
        setDragging(false); // Remove highlight when leaving
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false); // Remove highlight when dropping files
        const files = e.dataTransfer.files;
        handleFiles(files); // Handle dropped files
    };

    const handleFiles = (files) => {
        let size = 3000;
        let allowedfiles = [];
        let count = 0;
        const fileslist = Array.from(files)
        for (let n of fileslist) {
            count += (n.size * 0.001)
            if (count < size) {
                allowedfiles.push(n)
                console.log(count);
            }
        }
        if (fileslist.length !== allowedfiles.length) {
            toast({
                title: "Total Files size should be less than 3mb",
                description: "",
                duration: "2000",
                status: "warning",
                isClosable: "true"
            })
        }
        // setInputFiles((prev) => [...prev, ...fileslist])
        setInputFiles(allowedfiles)
    };

    const handleClick = () => {
        fileInputRef.current.click(); // Trigger file input click
    };

    const handleChange = (e) => {
        setEnvironmentTitle(e.target.value)
    }

    const createFile = async (e) => {
        e.preventDefault();

        let result = await create_environment_Api(environmentTitle)
        if (result.data) {
            setShowModal(false)
            toast({
                title: "Environment created successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            if (inputFiles.length > 0) {
                let file = await create_environment_file_Api(result.data.uuid, inputFiles)
                if (file.data) {
                    setShowModal(false)
                    toast({
                        title: "Files uploaded successfully",
                        description: "",
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                } else {
                    const errorMessage = file.error.message || "An error occurred"
                    toast({
                        title: "Problem uploading files ",
                        description: errorMessage,
                        status: "error",
                        duration: 2000,
                        isClosable: "true"
                    })
                    setInputFiles([])
                }
                fetchEnvironemnt()
            } else {
                setShowModal(false)
                fetchEnvironemnt()
            }
        } else {
            const errorMessage = result.error.message || "An error occurred.";
            toast({
                title: "Problem getting files",
                description: errorMessage,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleSignOut = async (e) => {
        let response = await logout_Api();
        if (response.data) {
            localStorage.removeItem("token")
            navigate("/loginnew/signIn")
            toast({
                title: "Signed Out Successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
        } else {
            toast({
                title: "Problem signing out",
                description: "Please try again later",
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleDelete = (todelete) => {
        setInputFiles((prev) => prev.filter(file => file.name != todelete))
    }

    const showEnvDetails = (env, i) => {
        setShowDetails({ show: true, env: env, id: i })
    }

    return (
        <div className={styles.environment_outer}>
            <CustomModal show={showmodal}>
                <div className={styles.modalouter}>
                    <div style={{ padding: '24px', borderRight: '0.6px solid var(--border)', width: '50%' }}>
                        <div className={styles.modalheader}>
                            New {data.environmenttitle}
                        </div>
                        <form className={styles.formouter} method='POST' onSubmit={createFile}>
                            <div className={styles.inputname}>
                                <label>{data.environmenttitle} Title<span style={{
                                    color: "var(--error)", fontWeight: '600'
                                }}>*</span></label>
                                <input type='text' name='environment_name' onChange={handleChange} maxLength={50} placeholder='Enter Environment Name' required />
                            </div>
                            <div className={`${styles.inputdiv} ${dragging ? styles.dragging : ''}`} onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}>
                                {dragging ? (
                                    // When dragging, show this content
                                    <div style={{ height: '133px' }}>
                                        Drag your file here
                                    </div>
                                ) : (
                                    <>
                                        <p>
                                            {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/upload_img.png"} alt='' /> */}
                                            <svg width="47" height="42" viewBox="0 0 47 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M30.9463 3.77734C31.3003 3.77734 31.5879 4.06488 31.5879 4.41895C31.5879 4.773 31.3004 5.06055 30.9463 5.06055C28.2931 5.06073 25.9029 6.77951 25.0469 9.27051L24.9688 9.51367C24.8781 9.81953 24.5795 10.005 24.2715 9.96387L24.2637 9.97363L24.1719 9.94531C23.8327 9.84417 23.6391 9.4879 23.7402 9.14844C24.6617 6.052 27.5312 3.77753 30.9463 3.77734Z" fill="var(--btn-bg)" stroke="#F9FFF9" stroke-width="0.3" />
                                                <path d="M37.8229 28.4884H34.8757C34.6045 28.4884 34.3845 28.2684 34.3845 27.9972C34.3845 27.726 34.6045 27.506 34.8757 27.506H37.8229C41.8854 27.506 45.1909 24.2005 45.1909 20.138C45.1909 16.0754 41.8854 12.7699 37.8229 12.7699H37.752C37.6096 12.7699 37.4741 12.7082 37.3808 12.6005C37.2875 12.4928 37.2454 12.35 37.2657 12.2089C37.3096 11.903 37.3317 11.5956 37.3317 11.2963C37.3317 7.77549 34.4669 4.91068 30.946 4.91068C29.5763 4.91068 28.27 5.33873 27.1683 6.14885C26.9262 6.32674 26.5823 6.2478 26.4424 5.98149C23.3222 0.0400754 15.1726 -0.757796 10.9475 4.41072C9.16764 6.58813 8.4683 9.42061 9.02869 12.1812C9.09044 12.4861 8.85711 12.7703 8.54731 12.7703H8.35047C4.28792 12.7703 0.982451 16.0758 0.982451 20.1383C0.982451 24.2009 4.28792 27.5064 8.35047 27.5064H11.2976C11.5689 27.5064 11.7889 27.7263 11.7889 27.9976C11.7889 28.2688 11.5689 28.4888 11.2976 28.4888H8.35047C3.74612 28.4888 0 24.7427 0 20.1383C0 15.6631 3.53873 11.9987 7.96488 11.7966C7.54911 8.93254 8.34416 6.04357 10.1868 3.789C14.7104 -1.74508 23.3796 -1.12478 27.0443 5.04612C28.2134 4.31317 29.5511 3.92867 30.9459 3.92867C35.2116 3.92867 38.5918 7.55937 38.296 11.8012C42.6814 12.0472 46.1731 15.6922 46.1731 20.1379C46.1731 24.7427 42.427 28.4884 37.8227 28.4884L37.8229 28.4884Z" fill="var(--btn-bg)" />
                                                <path d="M23.0205 14.6895C30.206 14.6895 36.0508 20.5342 36.0508 27.7197C36.0507 34.9051 30.206 40.75 23.0205 40.75C15.8351 40.75 9.99028 34.9053 9.99023 27.7197C9.99023 20.5343 15.8349 14.6895 23.0205 14.6895ZM23.0205 17.1719C17.2053 17.1719 12.4727 21.9046 12.4727 27.7197C12.4727 33.5349 17.2054 38.2676 23.0205 38.2676C28.8356 38.2675 33.5683 33.5348 33.5684 27.7197C33.5684 21.9045 28.8356 17.1719 23.0205 17.1719Z" fill="var(--btn-bg)" stroke="#F9FFF9" stroke-width="1.5" />
                                                <path d="M23.2444 33.0224C23.0458 33.0224 22.8848 32.8614 22.8848 32.6628V23.3127C22.8848 23.1142 23.0458 22.9531 23.2444 22.9531C23.4429 22.9531 23.604 23.1142 23.604 23.3127V32.6628C23.604 32.8616 23.4429 33.0224 23.2444 33.0224Z" fill="var(--btn-bg)" />
                                                <path d="M26.1213 26.5503C26.0294 26.5503 25.9371 26.5151 25.867 26.445L23.2444 23.8224L20.6218 26.445C20.4815 26.5855 20.2537 26.5855 20.1132 26.445C19.9727 26.3045 19.9727 26.0769 20.1132 25.9364L22.9901 23.0595C23.1303 22.919 23.3582 22.919 23.4987 23.0595L26.3756 25.9364C26.5161 26.0769 26.5161 26.3045 26.3756 26.445C26.3055 26.5154 26.2132 26.5503 26.1213 26.5503H26.1213Z" fill="var(--btn-bg)" />
                                            </svg>

                                        </p>
                                        <div>Upload your files</div>
                                        <p>Drag and drop your files here or <a onClick={handleClick} >choose files</a></p>
                                        <input
                                            type='file'
                                            name='project_name'
                                            placeholder='Enter Project Name'
                                            ref={fileInputRef}
                                            style={{ display: 'none' }} // hide the file input
                                            multiple
                                            onChange={(e) => handleFiles(e.target.files)}
                                        />
                                    </>
                                )}
                            </div>

                            <div className={styles.actionbtn}>
                                <button className={styles.btn1} onClick={() => (setShowModal(false), setInputFiles([]))}>Cancel</button>
                                <button className={styles.btn2} type='submit'>Create</button>
                            </div>
                        </form>
                    </div>

                    <div style={{ paddingBottom: '24px', width: '50%' }}>
                        <div className={styles.modalheader} style={{ padding: '24px 24px 18px 24px', borderBottom: '0.6px solid var(--border)' }}>
                            Uploaded {data.environmenttitle}
                        </div>
                        <div className={`${styles.envi_list} ${styles.scrollable}`} style={{ marginTop: '24px' }}>
                            {inputFiles ? inputFiles.map((file, id) => (
                                <div key={id}>
                                    <span>
                                        <p>{file.name}</p>
                                        <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>{file.type} I {file.size < 1000000 ? (file.size / 1024).toFixed(2) : file.size} {file.size < 1000000 ? "kb" : "mb"} </p>
                                    </span>
                                    <button onClick={() => handleDelete(file.name)}>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_45_3546)">
                                                <path d="M3.33398 5.83301H16.6673" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8.33398 9.16699V14.167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M11.666 9.16699V14.167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_45_3546">
                                                    <rect width="20" height="20" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>

                                    </button>
                                </div>
                            )) : ""}
                        </div>
                    </div>
                </div>
            </CustomModal >

            <div className={styles.environment_header}>
                <div className={styles.notification}>
                    <button style={{ color: "var(--text-primary)" }}>
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_41_1716)">
                                <path d="M10.832 5.41667C10.832 4.84203 11.0603 4.29093 11.4666 3.8846C11.873 3.47827 12.4241 3.25 12.9987 3.25C13.5733 3.25 14.1244 3.47827 14.5308 3.8846C14.9371 4.29093 15.1654 4.84203 15.1654 5.41667C16.4095 6.00495 17.47 6.92069 18.2334 8.06574C18.9968 9.2108 19.4342 10.542 19.4987 11.9167V15.1667C19.5802 15.8402 19.8188 16.4851 20.1951 17.0496C20.5714 17.6141 21.075 18.0824 21.6654 18.4167H4.33203C4.92238 18.0824 5.42599 17.6141 5.80232 17.0496C6.17864 16.4851 6.41717 15.8402 6.4987 15.1667V11.9167C6.56322 10.542 7.00061 9.2108 7.76398 8.06574C8.52735 6.92069 9.58792 6.00495 10.832 5.41667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.75 18.417V19.5003C9.75 20.3623 10.0924 21.1889 10.7019 21.7984C11.3114 22.4079 12.138 22.7503 13 22.7503C13.862 22.7503 14.6886 22.4079 15.2981 21.7984C15.9076 21.1889 16.25 20.3623 16.25 19.5003V18.417" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_41_1716">
                                    <rect width="26" height="26" rx="12" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                    <button>
                        <svg
                            width="26"
                            height="26"
                            viewBox="0 0 26 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="13"
                                cy="13"
                                r="9.75"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <circle
                                cx="13"
                                cy="18.417"
                                r="0.5"
                                fill="currentColor"
                            />
                            <path
                                d="M12.9987 14.6253C12.9788 14.2736 13.0736 13.9249 13.269 13.6319C13.4644 13.3388 13.7497 13.1171 14.082 13.0003C14.4892 12.8445 14.8547 12.5964 15.1497 12.2755C15.4447 11.9545 15.6612 11.5694 15.7821 11.1506C15.903 10.7317 15.9251 10.2905 15.8465 9.8617C15.7679 9.43288 15.5909 9.02816 15.3293 8.6794C15.0677 8.33064 14.7288 8.04735 14.3391 7.85185C13.9494 7.65634 13.5197 7.55395 13.0838 7.55275C12.6478 7.55154 12.2175 7.65154 11.8268 7.84488C11.4361 8.03822 11.0955 8.31962 10.832 8.66693"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                </div>
                <div className={`${styles.profile_section} togglebtn`} onClick={handledropdown}>
                    <div className={styles.profile_pic}>
                        {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/profilepic.png"} alt='profile_pic' style={{ height: "auto", width: "auto" }} /> */}


                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 512 512"
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlSpace="preserve"
                            role="img"
                        >
                            <path
                                fill="currentColor"
                                opacity="1.000000"
                                stroke="none"
                                d="M113.468658,513.000000 
	C111.720688,511.249115 109.736664,511.775635 108.005783,511.355164 
	C86.185883,506.054962 68.140289,494.908844 55.908623,475.806305 
	C47.265373,462.307922 42.561520,447.337189 42.646000,431.087891 
	C42.693653,421.922150 42.245129,412.734314 42.728165,403.593811 
	C44.634537,367.519592 50.289486,332.217560 67.974808,300.069031 
	C80.447807,277.395538 98.133179,260.192688 123.466881,252.204895 
	C134.789917,248.634705 146.427094,247.058701 158.307938,247.701218 
	C162.929565,247.951157 166.850403,250.242676 170.752045,252.479935 
	C182.849060,259.416504 193.782150,268.261597 206.480270,274.216461 
	C224.307114,282.576508 242.904236,288.142639 262.729614,286.473267 
	C284.581055,284.633209 304.740845,277.287872 322.942017,264.841003 
	C328.016846,261.370575 333.477478,258.429199 338.354797,254.711990 
	C350.109497,245.753220 363.289673,246.619751 376.533020,249.004440 
	C391.379395,251.677765 405.067902,257.274933 417.228668,266.523743 
	C428.128601,274.813629 436.567780,285.178131 443.307129,296.866364 
	C455.808563,318.548004 462.738861,342.113159 466.516083,366.803925 
	C468.880920,382.262177 469.758331,397.743958 470.670502,413.319122 
	C471.557312,428.461273 470.789337,443.248932 466.010681,457.446594 
	C456.619080,485.349579 436.746460,502.459229 408.607635,510.314270 
	C406.229736,510.978058 403.895203,511.797302 401.270264,512.772156 
	C305.312439,513.000000 209.624878,513.000000 113.468658,513.000000 
M192.499878,482.649841 
	C252.491852,482.649780 312.483948,482.704834 372.475647,482.580658 
	C380.070435,482.564941 387.726196,482.101410 395.212433,480.625336 
	C414.116425,476.897888 428.141571,466.863342 435.182831,448.456024 
	C438.829803,438.922028 439.656342,429.039703 438.937775,418.752594 
	C438.094910,406.686646 438.544891,394.562408 436.760895,382.502045 
	C433.254333,358.795929 428.554138,335.550201 416.313782,314.456665 
	C406.251373,297.116364 392.626923,284.598053 372.333038,280.878601 
	C367.422302,279.978577 362.331421,277.648163 357.348969,280.874481 
	C352.335510,284.120880 347.245911,287.257080 342.328491,290.643188 
	C319.277802,306.515717 293.733704,315.752808 265.966217,318.178772 
	C247.431442,319.798096 229.310104,316.537537 211.566071,310.875183 
	C193.457504,305.096497 177.374344,295.586670 161.973236,284.795013 
	C155.965622,280.585449 150.021103,278.418243 142.529922,280.305603 
	C131.126831,283.178558 120.266113,286.851959 111.662964,295.333344 
	C95.213432,311.550049 86.825279,332.069244 81.548470,353.888580 
	C75.676720,378.168030 73.461266,402.924896 74.235931,427.957336 
	C74.434052,434.359222 75.179420,440.513306 77.253944,446.516968 
	C82.178413,460.768433 91.491852,470.771332 105.408310,476.927826 
	C116.240433,481.719788 127.678604,482.089783 139.012527,482.485687 
	C156.488892,483.096191 174.002213,482.648285 192.499878,482.649841 
z"
                            />
                            <path
                                fill="currentColor"
                                opacity="1.000000"
                                stroke="none"
                                d="M275.531342,1.000000 
	C277.976776,3.561730 281.111389,3.004763 283.701385,3.611670 
	C306.015137,8.840423 325.033783,20.094219 341.094482,36.041897 
	C361.139374,55.945709 373.216827,79.937080 376.477966,108.354271 
	C379.399017,133.808151 375.936768,158.106964 364.337189,180.868851 
	C354.115601,200.926697 338.920135,216.839569 320.186829,229.332413 
	C303.527405,240.442200 284.952423,246.618683 265.226379,248.129227 
	C237.998611,250.214249 212.017914,245.408356 188.437057,230.541672 
	C166.023087,216.410629 149.263153,197.331940 138.703003,173.152039 
	C132.980469,160.048950 129.877243,146.114883 129.597916,131.629990 
	C129.324448,117.450157 129.732498,103.360313 133.718002,89.649910 
	C137.680756,76.017792 143.596054,63.283035 152.109787,51.831398 
	C163.252655,36.843388 176.802902,24.567564 193.046875,15.296743 
	C206.492432,7.623049 220.972656,3.164620 236.646973,1.146977 
	C249.687561,1.000000 262.375122,1.000000 275.531342,1.000000 
M191.922714,55.442963 
	C188.188934,58.298168 185.452606,62.068558 182.404205,65.579910 
	C162.591858,88.401192 157.794052,115.064476 163.084259,143.863449 
	C166.686066,163.471085 177.353348,179.281723 191.998688,192.736313 
	C214.581772,213.483261 241.026337,220.133316 270.722748,215.069153 
	C294.497620,211.014801 312.987976,198.069290 327.427643,179.226089 
	C344.418732,157.053360 349.024658,131.938858 343.692230,104.831802 
	C339.762512,84.855125 329.121735,68.965073 314.191254,55.293415 
	C293.345520,36.205288 268.662201,29.908751 241.445602,32.683411 
	C222.871674,34.576965 206.309967,42.104946 191.922714,55.442963 
z"
                            />
                        </svg>


                    </div>
                    <button style={{ color: "var(--text-primary)" }}>
                        {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/arrowhead.svg"} alt='toogle_btn' style={{
                            transform: show ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.3s ease', // Smooth rotation
                        }} /> */}
                        <svg style={{
                            transform: show ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.3s ease', // Smooth rotation
                        }} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                    {
                        show && <div ref={ref} className={styles.settingmodal}>
                            <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "20px" }}>
                                <h1>{userdetail}</h1>
                                <button onClick={handleSignOut}>Sign Out</button>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className={styles.environmentcreation_section}>
                <div>
                    <h1 className={styles.environment_title}>{data.environmenttitle}</h1>
                </div>
                <button className={`${styles.environment_buttons} ${styles.envbtn1}`} onClick={() => (setShowModal(true), setInputFiles([]))}>
                    <span>
                        {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/envfilesicon.png"} alt='icon' /> */}
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_32_166)">
                                <path d="M15 3V7C15 7.26522 15.1054 7.51957 15.2929 7.70711C15.4804 7.89464 15.7348 8 16 8H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M18 17H11C10.4696 17 9.96086 16.7893 9.58579 16.4142C9.21071 16.0391 9 15.5304 9 15V5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H15L20 8V15C20 15.5304 19.7893 16.0391 19.4142 16.4142C19.0391 16.7893 18.5304 17 18 17Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16 17V19C16 19.5304 15.7893 20.0391 15.4142 20.4142C15.0391 20.7893 14.5304 21 14 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V9C5 8.46957 5.21071 7.96086 5.58579 7.58579C5.96086 7.21071 6.46957 7 7 7H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_32_166">
                                    <rect width="24" height="24" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                    </span>
                    <span className={styles.line1}></span>
                    <p>Create Your Own</p>
                </button>
                <Link to="/templates" className={`${styles.environment_buttons} ${styles.envbtn2}`}>
                    <span>
                        {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/templatescon.png"} alt='icon' /> */}
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_32_180)">
                                <path d="M13 5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13 9H18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13 15H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13 19H18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3 5C3 4.73478 3.10536 4.48043 3.29289 4.29289C3.48043 4.10536 3.73478 4 4 4H8C8.26522 4 8.51957 4.10536 8.70711 4.29289C8.89464 4.48043 9 4.73478 9 5V9C9 9.26522 8.89464 9.51957 8.70711 9.70711C8.51957 9.89464 8.26522 10 8 10H4C3.73478 10 3.48043 9.89464 3.29289 9.70711C3.10536 9.51957 3 9.26522 3 9V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3 15C3 14.7348 3.10536 14.4804 3.29289 14.2929C3.48043 14.1054 3.73478 14 4 14H8C8.26522 14 8.51957 14.1054 8.70711 14.2929C8.89464 14.4804 9 14.7348 9 15V19C9 19.2652 8.89464 19.5196 8.70711 19.7071C8.51957 19.8946 8.26522 20 8 20H4C3.73478 20 3.48043 19.8946 3.29289 19.7071C3.10536 19.5196 3 19.2652 3 19V15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_32_180">
                                    <rect width="24" height="24" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                    </span>
                    <span className={styles.line2}></span>
                    <p>Browse Templates</p>
                </Link>
            </div>
            <div className={styles.environment_display}>
                <h1 className={styles.envlisttitle}>Added {data.environmenttitle}</h1>
                <div className={styles.envlist_outer}>
                    {environments ? environments.map((env, i) => (

                        <button onClick={() => showEnvDetails(env, i)} key={i} className={styles.envlist}>
                            {env.is_readonly ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-lock" viewBox="0 0 16 16">
                                <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1" />
                            </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-unlock" viewBox="0 0 16 16">
                                <path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2M3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z" />
                            </svg>}
                            <p>&nbsp;&nbsp;{env.name}</p>
                        </button>
                    )) : ""}
                </div>
            </div>
            {showDetails.show && <Environmentfiles showModal={showDetails.show} index={showDetails.id} file={showDetails.env} setshowdetails={setShowDetails} fetchenvi={fetchEnvironemnt} />}
        </div >
    )
}

export default Environmentpanel